<template>
  <admin-layout>
    <div class="content" slot="main">

      <div class="content-header">
        <h3>Campaigns <button type="button" class="btn btn-custom" @click="toggleShowCampaignModal()">Add New <i class="fa fa-plus"></i></button>
        </h3>
      </div>
      <table class="table table-striped">
        <tbody>
          <template v-for="item in campaignsByVendor">
            <template v-if="item.type == 'provider'">
              <tr>
                <th v-if="item.type == 'provider'" colspan="4" class="vendor-header">
                  <a href="#" v-on:click.prevent.stop="toggleShowProviderModal(item.provider)">{{ item.name }}</a>
                </th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Campaign Type</th>
                <th>Active</th>
                <th>Test</th>
              </tr>
            </template>
            <template v-else>
              <tr>
                <th v-if="item.type == 'campaign'" class="campaign-name">
                  <span v-if="item.campaign_type == 'google'"><i class="fa fa-google"></i> - </span>
                  <span v-if="item.campaign_type == 'facebook'"><i class="fa fa-facebook"></i> - </span>
                  <span v-if="item.campaign_type == 'ping-post'"><i class="fa fa-money"></i> - </span>
                  <span v-if="item.campaign_type == 'appointment'"><i class="fa fa-calendar"></i> - </span>
                  <a href="#" v-on:click.prevent.stop="toggleShowCampaignModal(item.id)">{{item.name}}</a>
                  <tags-widget :tagsDb="tagsDb" :readOnly="true" :tags="item.tags"></tags-widget>
                </th>
                <td v-if="item.type == 'campaign'" class="text-capitalize">{{ item.campaign_type }}</td>
                <td v-if="item.type == 'campaign'"><yes-no :ok="item.is_active"></yes-no></td>
                <td v-if="item.type == 'campaign'"><yes-no :ok="item.is_test"></yes-no></td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div slot="modals">
      <campaign-modal v-if="showCampaignModal" :campaign="campaign" @close="closeCampaignModal"></campaign-modal>
      <provider-modal v-if="showProviderModal" :provider="provider" @close="closeProviderModal"></provider-modal>
    </div>
  </admin-layout>
</template>

<script>
 import Vue from 'vue';


 import {AdminLayout} from 'components/layouts/';
 import {CampaignModal, ProviderModal} from 'components/modals/';
 import YesNo from 'components/elements/YesNo';
 import TagsWidget from 'components/elements/TagsWidget';


 // Load the full build.
 var _ = require('lodash');

 export default {
     components: {
         AdminLayout,
         CampaignModal,
         ProviderModal,
         TagsWidget,
         YesNo,
     },
     data () {
         return {
             loading: false,

             campaign: null,
             provider: null,
             campaignList: [],
             showCampaignModal: false,
             showProviderModal: false,
             tagsDb: {}
         };
     },
     computed: {
         campaignsByVendor() {
             var res = []
             var vendor = null;

             this.campaignList.forEach(function (item) {
                 if (item.provider != vendor) {
                     res.push({
                         type: 'provider',
                         provider: item.provider,
                         name: item.provider_name
                     });
                     vendor = item.provider;
                 }
                 res.push({
                     type: 'campaign',
                     id: item.id,
                     name: item.name,
                     is_active: item.is_active,
                     is_test: item.is_test,
                     campaign_type: item.campaign_type,
                     tags: item.tags
                 });
             });

             return res;
         }
     },
     created () {
         this.fetchInitialData();
     },


     methods: {
         fetchInitialData () {
             this.fetchTags();
             this.fetchCampaigns();
         },
         async fetchTags() {
             const res = await API.tags.getList();
             this.tagsDb = Object.fromEntries( res.data.results.map(t => [t.id, t]));
         },
         fetchCampaigns() {
             var self = this;
             API.campaigns.getList()
                .then(function (response) {
                    self.campaignList = response.data;
                });
         },
         toggleShowCampaignModal (campaignModel) {
             if (campaignModel !== undefined) {
                 this.campaign = campaignModel;
             }
             else {
                 this.campaign = null;
             }
             this.showCampaignModal = true;
         },
         toggleShowProviderModal (providerModel) {
             if (providerModel !== undefined) {
                 this.provider = providerModel;
             }
             else {
                 this.provider = null;
             }
             this.showProviderModal = true;
         },
         closeCampaignModal (refresh) {
             this.campaign = undefined;
             this.showCampaignModal = false;

             if (refresh) {
                 this.fetchCampaigns();
             }
         },
         closeProviderModal () {
             this.provider = undefined;
             this.showProviderModal = false;
         },
         removeCampaign (campaignId) {
             var self = this;
             var r = confirm("This action will be permanently and it can't be recovered. Are you sure you want to continue?");
         },
     }
 }
</script>


<style scoped>
 .vendor-header {
     text-align: center;
     background-color: #eee;
     color: #333;
 }
 .tags-widget {
     display: inline-block;
 }


</style>



// WEBPACK FOOTER //
// CampaignsSettings.vue?5865ea26